import {Injectable} from "@angular/core";
import {UserRemote} from "@app/core/user/domain/user.remote";
import {concat, Observable, switchMap} from "rxjs";
import {LogoutUseCase} from "@app/core/user/application/logout.use-case";

/**
 * Use case for deleting a current user account and performing the necessary steps after account deletion.
 */
 @Injectable({
    providedIn: "root",
})
export class DeleteAccountUseCase {

    constructor(
        private userRemote: UserRemote,
        private logoutUseCase: LogoutUseCase,
    ) { }

    execute(): Observable<void> {
        return concat(
            this.userRemote.deleteAccount(),
        ).pipe(
            switchMap(() =>
                this.logoutUseCase.execute()
            ),
        );
    }
}
